module.exports = Joi => Joi.string().guid()
